// extracted by mini-css-extract-plugin
export default {"CustomerSoonContent":"CustomerSoon_CustomerSoonContent__jxt8U","ownerImg":"CustomerSoon_ownerImg__s+sfd","soonLogo":"CustomerSoon_soonLogo__jpVKy"};